import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import ArticleCard from '@/components/feature/ArticleCard';
import type { Article } from '@/mocks/articles';

interface HotRankingProps {
  hotArticles: Article[];
  followUp: Article;
}

export default function HotRanking({ hotArticles, followUp }: HotRankingProps) {
  return (
    <section id="hot" className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <SectionTitle
          eyebrow="24 小时热榜"
          title="正在被反复点开的事件"
          desc="按阅读量实时排序，每 30 分钟更新一次。带图解的条目会标注在右侧。"
        />
        <Link
          to="/feed"
          className="shrink-0 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          查看全部线报
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7 rounded-lg bg-background-50 border border-background-200/80 px-5 md:px-6">
          {hotArticles.map((article, index) => (
            <ArticleCard key={article.id} article={article} variant="row" index={index} />
          ))}
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-lg bg-secondary-950 text-background-100 p-6 md:p-7 h-full flex flex-col">
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.28em] uppercase text-accent-400">
              <span className="w-6 h-px bg-accent-500" />
              后续反映
            </span>
            <h3 className="mt-3 font-heading text-lg md:text-xl font-bold text-background-50 leading-snug">
              {followUp.title}
            </h3>
            <ol className="mt-6 space-y-4 flex-1">
              {followUp.timeline.map((item) => (
                <li key={item.time} className="relative pl-6">
                  <span className="absolute left-0 top-1.5 w-2.5 h-2.5 rounded-full bg-accent-500" />
                  <span className="absolute left-[4px] top-4 bottom-[-16px] w-px bg-secondary-700" />
                  <div className="text-xs font-medium text-accent-400">{item.time}</div>
                  <p className="mt-1 text-sm text-background-200 leading-relaxed">{item.text}</p>
                </li>
              ))}
            </ol>
            <Link
              to={`/article/${followUp.slug}`}
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-background-50 hover:text-accent-400 transition-colors whitespace-nowrap"
            >
              阅读完整脉络
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}